import script from "./CallbackRequestsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CallbackRequestsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__